import React from "react";

const KeysWindow = ({ handleButton }) => {
  const sciKeys = ["sin", "cos", "tan", "sin⁻¹", "cos⁻¹", "tan⁻¹", "ln", "log", "π", "e", "^", "!", "√", "³√", "⁴√", "nPr", "nCr", ""];

  const basicKeys = ["AC", "DEL", "(", ")", "/", "7", "8", "9", "*", ".", "4", "5", "6", "-", "+", "1", "2", "3", "0", "="];

  return (
    <div className="keysWindow">
      <div className="keys_scientific">
        {sciKeys.map((item, index) =>
          item === "" ? (
            <div key={index} style={{ visibility: "hidden" }}></div>
          ) : (
            <button key={index} onClick={() => handleButton(item)}>
              {item}
            </button>
          )
        )}
      </div>
      <div className="line"></div>
      <div className="keys_basic">
        {basicKeys.map((item, index) => (
          <button key={index} className={`${item >= "0" && item <= "9" ? "number" : ""} ${item === "=" && "equal"}`} onClick={() => handleButton(item)}>
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};

export default KeysWindow;
